import axios from "axios";

export const http = axios.create({
         baseURL: "http://203.95.222.126:3000/api",
         timeout: 10000,
       });


class DataService {
  save(data) {
    return http.post("save", data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  }
  
  getTeachers() {
    return http.get("teachers");
  }
  getSubjects(teacherId) {
    return http.get("subjects", { params: { teacherId: teacherId } });
  }
  getBatches(subjectId) {
    return http.get("batches", { params: { subjectId: subjectId } });
  }
}
export default new DataService();
